import { ClipLoader } from 'react-spinners'

export default function Spinner() {
	return (
		<div className="flex min-h-screen items-center justify-center">
			<ClipLoader color="#2463eb" size={50} />
		</div>
	)
}
